function toFiniteNumber(input) {
  if (input === null || input === undefined || input === '') {
    return null;
  }

  const numeric = Number(input);

  return Number.isFinite(numeric) ? numeric : null;
}

/**
 * Compares a stat value against the rank/peer average the coach API returns.
 *
 * Returns null when no comparison can be made. The coach API sends 0 (not null)
 * for stats it has no rank data for — that happens per map, so a player whose
 * most played map has no peer data gets 0 for every stat. Dividing by a
 * substituted 1 turned those into percentages the size of the raw value, e.g.
 * "106370192300% worse" for a nanosecond stat.
 *
 * @param {number} value - the player's value for this stat
 * @param {number} average - the rank average (`rating_range_average_value`/`avg`)
 * @param {boolean} isAscending - true when a higher value is better
 * @returns {{difference: number, percentDifference: number} | null}
 */
export function compareStatToAverage(value, average, isAscending) {
  const playerValue = toFiniteNumber(value);
  const averageValue = toFiniteNumber(average);

  if (playerValue === null || averageValue === null || averageValue === 0) {
    return null;
  }

  const difference = isAscending ? playerValue - averageValue : averageValue - playerValue;

  return {
    difference,
    percentDifference: (difference / averageValue) * 100,
  };
}

/**
 * True when a stat has a rank average to compare against.
 *
 * @param {number} average - the rank average (`rating_range_average_value`/`avg`)
 */
export function hasRankAverage(average) {
  const averageValue = toFiniteNumber(average);

  return averageValue !== null && averageValue !== 0;
}
